import {
  Component,
  input,
  OnInit,
  output,
  Signal,
  signal,
} from '@angular/core';
import { Router } from '@angular/router';
import { UIService } from 'src/app/app-services/ui.service';
import { UntilDestroy } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
  selector: 'w-h-back-button',
  templateUrl: './w-h-back-button.component.html',
  styleUrl: './w-h-back-button.component.scss',
  standalone: false,
})
export class WHBackButtonComponent implements OnInit {
  labelTranslateKey = input('app.back.label');
  hideLabel = input(false);
  fallbackRoute = input(null);
  handleManually = input(false);
  onBackClick = output<void>();

  isXLScreen: Signal<boolean> = signal(false);

  constructor(
    private uiService: UIService,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.isXLScreen = this.uiService.$isXLScreen ?? signal(false);
  }

  onBackButtonClick(event?: Event) {
    if (this.handleManually()) {
      this.onBackClick.emit();
      return;
    }

    if (event) {
      event.stopPropagation();
      event.preventDefault();
    }

    const explicitBackTarget = this.getExplicitBackTarget();
    if (explicitBackTarget) {
      this.router.navigate([explicitBackTarget], { replaceUrl: true });
      return;
    }

    if (this.uiService.hasInAppNavigation()) {
      window.history.back();
    } else {
      // First navigation or external entry - use fallback and replace history
      const fallback = this.fallbackRoute() || this.getFirstSegmentFallback();
      this.router.navigate([fallback], { replaceUrl: true });
    }
  }

  private getFirstSegmentFallback(): string {
    // Get first URL segment after domain (e.g., /projects/123 -> /projects)
    const currentPath = window.location.pathname;
    const segments = currentPath.split('/').filter((s) => s);
    return segments.length > 0 ? `/${segments[0]}` : '/';
  }

  private getExplicitBackTarget(): string | null {
    const params = new URLSearchParams(window.location.search);
    const backTo = params.get('backTo');

    if (backTo === null) {
      return null;
    }

    if (backTo === '') {
      return '/';
    }

    return backTo.startsWith('/') ? backTo : `/${backTo}`;
  }
}
